import { Capacitor, registerPlugin } from '@capacitor/core';

const AudioStatePlugin = registerPlugin('AudioState');

export const getAndroidAudioState = async () => {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') {
    return null;
  }

  try {
    const result = await AudioStatePlugin.getState();
    return result || null;
  } catch (err) {
    console.warn('Failed to read Android audio state:', err);
    return null;
  }
};
